import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[queryRemoveButton]'})
export class QueryRemoveButtonDirective {
  constructor(public template: TemplateRef<any>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/query-builder/query-remove-button.directive.ts